import {StillImageBackground} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {IGameModeChangedData} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {RomanEmpireGameConfig} from "../RomanEmpireGameConfig";
import {RomanEmpireGameMode} from "../gamemode/RomanEmpireGameMode";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TimelineLite, TweenLite} from "gsap";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";

export class IStillImageBackground extends StillImageBackground {
    private _backgroundWall: PIXI.Sprite;
    private _leftcloud: PIXI.Sprite;
    private _leftpinkcloud: PIXI.Sprite;
    private _rightcloud: PIXI.Sprite;
    private _rightpinkcloud: PIXI.Sprite;
    private _screenBounds: ScreenBounds;
    private _playcloudAnimation: boolean = false;
    private _tl: TimelineLite;
    private _reelFireSpineAnim: PIXI.spine.Spine;


    protected onResize(resizeData: IResizeData): void {
        super.onResize && super.onResize(resizeData);
        // if (Object.is(resizeData.orientation, Orientation.PORTRAIT)) {
        //   this.hideCloudAnimation();
        // }
        // else {
        //     if(!this._playcloudAnimation){
        //         this._playcloudAnimation=true;
        this.positionCloudsAndPlayAnimation(); // cloud animation to be played in portrait too
        // }
        // }
    }

    protected initAnimations(): void {
        super.initAnimations();
        this._tl = new TimelineLite();
        this.createSprites();
        this.spriteScaleAndAnchor();
        this.addChild(this._leftcloud, this._leftpinkcloud, this._rightcloud, this._rightpinkcloud, this._backgroundWall);
        this.playspinAnimationOnReelBackground();
    }


    private playspinAnimationOnReelBackground(): void {
     this._reelFireSpineAnim = new PIXI.spine.Spine(GameResources.getSpineAsset("Reelframe_effect"));
        this._reelFireSpineAnim.pivot.set(0.5);
        this._reelFireSpineAnim.position.set(RomanEmpireGameConfig.instance.REEL_AREA_CENTER_X,RomanEmpireGameConfig.instance.REEL_AREA_HEIGHT*0.6)
        StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.BACKGROUND.name).addChild(this._reelFireSpineAnim)
    }


    private spriteScaleAndAnchor(): void {
        this._leftcloud.anchor.set(0.5);
        this._leftpinkcloud.anchor.set(0.5);
        // this._leftpinkcloud.scale.set(0.8);
        this._rightcloud.anchor.set(0.5);
        this._leftcloud.width*=-1;
        // this._rightcloud.scale.set(0.8);
        // this._rightpinkcloud.scale.set(0.8);
    }

    private createSprites(): void {
        this._backgroundWall = new PIXI.Sprite();
        this._leftcloud = new PIXI.Sprite();
        this._leftpinkcloud = new PIXI.Sprite();
        this._rightcloud = new PIXI.Sprite();
        this._rightpinkcloud = new PIXI.Sprite();
        this._backgroundWall.texture = GameResources.getTextures("mainBackgroundWall")[0];
        this._leftcloud.texture = GameResources.getTextures("clound_pink_right")[0];
        this._leftpinkcloud.texture = GameResources.getTextures("cloud_pink_left")[0];
        this._rightcloud.texture = GameResources.getTextures("rightCloud")[0];
        this._rightpinkcloud.texture = GameResources.getTextures("clound_pink_right")[0];
    }

    protected onChangeBackground(data: IGameModeChangedData): boolean {
        if (!super.onChangeBackground(data)) {
            return false;
        }
        if (Object.is(data.newMode, RomanEmpireGameMode.NORMAL)) {
            this._backgroundWall.visible = true;
            this._playcloudAnimation = true;
            this.positionCloudsAndPlayAnimation();
            this._tl.kill();
            this._reelFireSpineAnim.visible=false;
        } else {
            this.hideCloudAnimation()
            this._backgroundWall.visible = false;
            this._reelFireSpineAnim.visible=true;
            this._tl.add(new SpineTween(this._reelFireSpineAnim, 0, "fs_reelframe_effect",-1), 0);

        }
        const offset: PIXI.Point = this._backgroundImages[this._currentMode].offset != undefined ? this._backgroundImages[this._currentMode].offset! : new PIXI.Point(0, 0,);
        const scale: number = this._backgroundImages[this._currentMode].scale != undefined ? this._backgroundImages[this._currentMode].scale! : 1;
        if (this._stretch) {
            this._backgroundWall.width = RomanEmpireGameConfig.instance.GAME_WIDTH;
            this._backgroundWall.height = RomanEmpireGameConfig.instance.GAME_HEIGHT;
        } else {
            this._backgroundWall.scale.set(scale, scale);
        }
        this._backgroundWall.x = offset.x;
        this._backgroundWall.y = offset.y;

        return true;
    }

    private hideCloudAnimation(): void {
        this._rightcloud.visible = false;
        this._rightpinkcloud.visible = false;
        this._leftcloud.visible = false
        this._leftpinkcloud.visible = false
        this._playcloudAnimation = false;
    }

    private positionCloudsAndPlayAnimation(): void {
        this._screenBounds = NolimitApplication.screenBounds;
        this.rightCloudAnimation();
        this.leftCloudAnimation()
    }


    private rightCloudAnimation(): void {
        if (!this._playcloudAnimation) {
            return;
        }
        this._rightcloud.visible = true;
        this._rightpinkcloud.visible = true;
        this._rightcloud.position.set(this._screenBounds.right + this._rightcloud.width * 0.4, this._screenBounds.top + this._rightcloud.height *0.7)
        this._rightpinkcloud.position.set(this._screenBounds.right + this._rightpinkcloud.width * 0.4, this._screenBounds.top + this._rightpinkcloud.height *1.7)
        TweenLite.fromTo(this._rightcloud, 90, {x: this._rightcloud.x}, {
            x: this._screenBounds.left - this._rightcloud.width * 0.5
        });
        TweenLite.fromTo(this._rightpinkcloud, 90, {x: this._rightpinkcloud.x}, {
            x: this._screenBounds.left - this._rightpinkcloud.width,
            onComplete: () => {
                TweenLite.killTweensOf(this.rightCloudAnimation());
                this.rightCloudAnimation();
            }
        });
    }

    private leftCloudAnimation(): void {
        if (!this._playcloudAnimation) {
            return;
        }
        this._leftcloud.visible = true;
        this._leftpinkcloud.visible = true;
        this._leftcloud.position.set(this._screenBounds.left - this._leftcloud.width * 0.5, this._screenBounds.top + this._leftcloud.height *2.5)
        this._leftpinkcloud.position.set(this._screenBounds.left - this._leftpinkcloud.width , this._screenBounds.top + this._leftpinkcloud.height * 0.9)
        TweenLite.fromTo(this._leftcloud, 90, {x: this._leftcloud.x}, {
            x: this._screenBounds.right + this._leftcloud.width * 0.5

        });
        TweenLite.fromTo(this._leftpinkcloud, 90, {x: this._leftpinkcloud.x}, {
            x: this._screenBounds.right + this._leftpinkcloud.width * 0.5, onComplete: () => {
                TweenLite.killTweensOf(this.leftCloudAnimation());
                this.leftCloudAnimation();
            }
        });
    }


}